import { Button, Container, Flex, Stack, Title } from "@mantine/core";
import React, { useEffect, useState } from "react";
import OrganizationSettingsForm from "./OrganizationSettingsForm";
import OrganizationDeviceList from "./OrganizationDeviceList";
import UserList from "../user_settings/parts/UserList";
import { patchOrganizationDist } from "../../utils/api-communication/RestApiCli";
import { useTranslation } from "react-i18next";
import AuditTrailButton from "../audit_trail/AuditTrailButton";
import { getRole } from "@utils/CommonUtil";
import { Role } from "@model/role";

export default function OrganizationManagementDashboard(props) {
  const { t } = useTranslation();
  const [organization, setOrganization] = useState(null);
  const isSuperAdmin = getRole() === Role.SuperAdmin;

  useEffect(() => {
    setOrganization(props.organization);
  }, [props.organization]);

  return organization ? (
    <Container mt={"lg"} pt={"lg"}>
      <Stack>
        <Flex justify={"space-between"} align={"center"}>
          <Title>{organization.name}</Title>
          <Flex gap="sm" align="center">
            {/* Reading another organization's trail is a SuperAdmin-only
                capability, so the button is hidden for everyone else rather
                than leading them to a 403. */}
            {isSuperAdmin && <AuditTrailButton orgId={organization.orgId} />}
            <Button onClick={() => props.back()} variant="outline">
              {t("return")}
            </Button>
          </Flex>
        </Flex>
        <OrganizationSettingsForm
          organization={organization}
          updateOrgInfo={(org, onSuccess, onError) =>
            patchOrganizationDist(
              org.orgId,
              {
                address: org.address,
                name: org.name,
                email: org.email,
                accountType: org.accountType,
                accountInfo: org.accountInfo,
              },
              (response) => {
                // Update local state with the updated organization data
                setOrganization((prev) => ({
                  ...prev,
                  ...response.data,
                }));
                onSuccess(response);
              },
              onError,
            )
          }
          updateOrganization={props.updateOrganization}
        />
        <OrganizationDeviceList organization={organization} isDist={true} />
        <UserList orgId={organization.orgId} onOrgIdChanged={() => props.back()} />
      </Stack>
    </Container>
  ) : null;
}
